var $8cc39eb66c2bf220$exports = {};
$8cc39eb66c2bf220$exports = {
  "ascending": "de subida",
  "ascendingSort": function ascendingSort(args) {
    return "ordenado por columna ".concat(args.columnName, " en orden de subida");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " p\xEDxeles");
  },
  "descending": "de bajada",
  "descendingSort": function descendingSort(args) {
    return "ordenado por columna ".concat(args.columnName, " en orden de bajada");
  },
  "resizerDescription": "Pulse Intro para empezar a redimensionar",
  "select": "Seleccionar",
  "selectAll": "Seleccionar todos",
  "sortable": "columna ordenable"
};
export { $8cc39eb66c2bf220$exports as default };